import {
	AssessableItem,
	AssessableItemGroup,
	AudioFile,
	ChecklistItem,
	ComponentStatusView,
	DynamicAssignedAudioChannelGroup,
	FileSetConversionView,
	IId,
	Marker,
	ScenarioRecordingGroup,
	UserClientTypeView,
	VideoFile,
} from "@models";
import {SettingsTable} from "../../modules/web-manager/subModules/sim-admin-settings/pages/sim-admin-settings-general-settings/sim-admin-settings-general-settings.component";

/**
 * This utillity class contains all trackby (identity) methods
 * In order to decrease code duplicates
 */
export class TrackByMethods {
	public static trackById<T extends IId>(index: number, obj: T) {
		return obj.id;
	}

	public static trackByMarkerId(index: number, marker: Marker) {
		return marker?.markerId;
	}

	public static trackByScenarioRecordingGroupId(index: number, scenarioRecordingGroup: ScenarioRecordingGroup) {
		return scenarioRecordingGroup.scenarioRecordingGroupId;
	}

	public static trackByComponentSatusView<T extends ComponentStatusView>(index: number, value: T) {
		return `${value?.guid}-${value?.guid ?? 0}`;
	}

	public static trackByConversionInfo(index: number, conversionInfo: FileSetConversionView) {
		return conversionInfo.conversionProcessInfoId;
	}

	public static trackByAssessableItemGroups<T extends AssessableItem>(index: number, obj: AssessableItemGroup<T>) {
		return obj.groupId;
	}

	public static trackByIdChannelGroup(index: number, channelGroup: DynamicAssignedAudioChannelGroup): string {
		return channelGroup.audioChannelGroupId;
	}
	public static trackByAssessableItem<T extends AssessableItem>(index: number, obj: T) {
		return obj.assessableItemId;
	}

	public static trackByChecklistItem(index: number, obj: ChecklistItem) {
		return obj.checklistItemId;
	}

	public static trackByIndex<T>(index: number, obj: T) {
		return index;
	}

	public static trackByName(index: number, obj: {name: string}): string {
		return obj.name;
	}

	public static trackByClientId(index: number, device: {clientId: string; userId: string}): string {
		return device?.clientId;
	}

	public static trackByUserClientType(index: number, userClientType: UserClientTypeView): string {
		return userClientType?.simUserId;
	}

	public static trackBySettingsTable(index: number, settingsTable: SettingsTable) {
		return settingsTable.categoryName;
	}

	public static trackByPrimitive(index: number, value: string) {
		return value;
	}

	public static trackByVideoFile(index: number, value: VideoFile) {
		return value.videoFileId;
	}

	public static trackByAudioFile(index: number, value: AudioFile) {
		return value.audioFileId;
	}
}
